import * as React from 'react';
import * as COLOURS from '../../../constants/colours';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

const customTheme = (outerTheme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            marginBottom: 24,

            '& label': {
              color: '#707070',
              opacity: 0.6,
              fontFamily: 'Roboto',
              fontSize: 18,
            },

            '& label.Mui-focused': {
              color: COLOURS.soltaColor,
            },
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            fontSize: 21,
            fontFamily: 'Roboto',
            color: '#707070',
            '&:before': {
              borderBottom: `1px solid ${COLOURS.soltaColor}`,
            },
            '&:hover:not(.Mui-disabled, .Mui-error):before': {
              borderBottom: `2px solid ${COLOURS.soltaColor}`,
            },
            '&.Mui-focused:after': {
              borderBottom: `2px solid ${COLOURS.soltaColor}`,
            },
          },
        },
      },
    },
  });

export default function SoltaTextField(props) {
  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <TextField {...props} fullWidth />
    </ThemeProvider>
  );
}
